import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/common/scrollToTop';
import 'react-widgets/dist/css/react-widgets.css';
import './css/semantic/semantic.css';
import App from './pages/App.jsx';
import {bootstrapNativeUploadBetaFromQueryParam} from './utils/nativeUploadBeta';

bootstrapNativeUploadBetaFromQueryParam();

ReactDOM.render((
  <BrowserRouter>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </BrowserRouter>

  ), document.getElementById('root')
);



// WEBPACK FOOTER //
// ./public/index.js